import React, { FC } from "react";
import { toast } from "react-toastify";

import { IgButton, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { intelligemsFullThemeSnippet } from "../../utils/intelligemsThemeSnippets";

interface ScriptCopyProps {
  organizationId?: string;
}
export const ScriptCopy = ({ organizationId }: ScriptCopyProps) => {
  const onCopyClick = async () => {
    await navigator.clipboard.writeText(
      `${intelligemsFullThemeSnippet}
                            <script src="https://cdn.intelligems.io/${organizationId}.js"></script>`
    );
    toast.success("Script Copied!");
  };
  return (
    <IgPaper>
      <Grid container direction={"column"} rowSpacing={1}>
        <Grid
          item
          xs={12}
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Grid item>
            <IgTypography variant="h6">Theme Script</IgTypography>
          </Grid>
          <Grid item>
            <IgButton
              onClick={() => {
                void onCopyClick();
              }}
              variant={"contained"}
            >
              Copy Script
            </IgButton>
          </Grid>
        </Grid>
        <Grid item>
          <IgTypography
            sx={{
              fontFamily: "monospace",
              fontWeight: 400,
              fontSize: "12px",
            }}
          >
            <Grid item>{"<script>"}</Grid>
            <Grid item ml={2}>
              {`window.Shopify = window.Shopify || {theme: {id: {{ theme.id }}, role: '{{ theme.role }}' } };`}
            </Grid>
            <Grid ml={2} item>{`window._template = {`}</Grid>
            <Grid ml={6} item>{`directory: "{{ template.directory }}",`}</Grid>
            <Grid ml={6} item>{`name: "{{ template.name }}",`}</Grid>
            <Grid ml={6} item>{`suffix: "{{ template.suffix }}"`}</Grid>
            <Grid xs={12} ml={2} item>{`};`}</Grid>
            <Grid item>{`</script>`}</Grid>
            <Grid item>
              {`<script src="https://cdn.intelligems.io/${organizationId}.js"></script>`}
            </Grid>
          </IgTypography>
        </Grid>
      </Grid>
    </IgPaper>
  );
};
